import { images } from "./images";
import { projects } from "./data";

const services = [
  {
    id: "custom-interior",
    name: "Custom Interior",
    tagline: "Interior rumah dan venue secara menyeluruh, dirangkai ruang demi ruang.",
    bullets: [
      "Konsep dan tata ruang ruang demi ruang",
      "Perencanaan furnitur, pencahayaan, dan material",
      "Pengawasan penuh hingga serah terima",
    ],
    img: images.hero,
  },
  {
    id: "interior-design",
    name: "Desain Interior",
    tagline: "Konsep, tata ruang, dan desain 3D untuk memberi arah yang jelas pada proyek Anda.",
    bullets: [
      "Papan konsep dan arahan mood",
      "Visualisasi 3D setiap ruang utama",
      "Gambar teknis yang detail",
    ],
    img: images.editorial,
  },
  {
    id: "kitchen-set",
    name: "Kitchen Set Kustom",
    tagline: "Dapur dibuat sesuai ukuran — kayu solid, plywood, atau beton ringan.",
    bullets: [
      "Kayu solid, plywood, atau beton ringan",
      "Meja kerja batu, solid surface, dan kayu",
      "Konstruksi berventilasi, siap iklim tropis",
    ],
    img: images.kitchenDark,
  },
  {
    id: "bedroom-set",
    name: "Bedroom Set",
    tagline: "Tempat tidur, lemari, dan nakas dirancang sebagai satu set yang tenang.",
    bullets: [
      "Rangka tempat tidur, headboard, dan nakas",
      "Lemari built-in dan walk-in",
      "Desain pencahayaan lembut berlapis",
    ],
    img: images.bedroomWarm,
  },
  {
    id: "tv-backdrop",
    name: "TV Backdrop",
    tagline: "Dinding aksen yang membingkai ruang keluarga dan menyembunyikan kabel.",
    bullets: [
      "Finis kayu garis, batu, atau plester",
      "Kabel tersembunyi dan penyimpanan media",
      "Pencahayaan ambient tersembunyi",
    ],
    img: images.tvBackdrop,
  },
  {
    id: "wall-panel",
    name: "Panel Dinding",
    tagline: "Panel garis, fluting, dan solid yang menambah kehangatan dan ritme.",
    bullets: [
      "Panel fluting, garis, dan solid",
      "Kesinambungan dinding hingga plafon",
      "Pilihan akustik dan tekstur",
    ],
    img: images.texture,
  },
  {
    id: "storage",
    name: "Storage",
    tagline: "Lemari, rak, dan penyimpanan ukuran pesanan untuk setiap sudut.",
    bullets: [
      "Lemari dan rak ukuran pesanan",
      "Penyimpanan tersembunyi dan detail joinery",
      "Solusi untuk setiap sudut",
    ],
    img: images.wardrobe,
  },
  {
    id: "custom-furniture",
    name: "Furnitur Kustom",
    tagline: "Meja, kursi, dan kabinet pesanan khusus dari jati dan kayu keras.",
    bullets: [
      "Meja, kursi, dan kabinet pesanan khusus",
      "Konstruksi jati solid dan kayu keras",
      "Difinisi dengan tangan di workshop kami",
    ],
    img: images.dining,
  },
  {
    id: "design-build",
    name: "Desain & Bangun Interior",
    tagline: "Satu tim bertanggung jawab penuh dari gambar desain hingga pemasangan di lokasi.",
    bullets: [
      "Satu tim dari sketsa hingga pemasangan",
      "Izin, vendor, dan linimasa dikelola",
      "Satu titik tanggung jawab",
    ],
    img: images.villaArchitecture,
  },
];

export const id = {
  meta: {
    title: "Samasta Studio — Desain Interior & Furnitur Kustom, Bali",
  },
  nav: {
    home: "Beranda",
    about: "Tentang",
    services: "Layanan",
    portfolio: "Portofolio",
    contact: "Kontak",
    cta: "Konsultasi",
    waMessage: "Halo Samasta Studio, saya ingin mendiskusikan proyek interior.",
    menuLabel: "Menu",
    closeLabel: "Tutup",
  },
  common: {
    explorePortfolio: "Lihat Portofolio",
    consultWhatsapp: "Konsultasi via WhatsApp",
    viewAll: "Lihat semua proyek",
    allServices: "Semua layanan",
    aboutStudio: "Tentang studio",
    discussProject: "Diskusi via WhatsApp",
    chatWhatsapp: "Chat via WhatsApp",
    sendWhatsapp: "Kirim via WhatsApp",
    craftedInBali: "Dibuat di Bali",
    rights: "Hak cipta dilindungi.",
    included: "Yang termasuk",
  },
  home: {
    hero: {
      eyebrow: "Desain Interior & Furnitur Kustom — Bali",
      line1: "Interior yang abadi,",
      line2: "diciptakan di Bali.",
      sub: "Samasta Studio merancang dan membangun interior kustom serta furnitur pesanan — dari satu panel dinding hingga vila utuh — untuk rumah, vila, restoran, dan toko di seluruh pulau.",
      ctaPrimary: "Lihat Portofolio",
      ctaSecondary: "Konsultasi via WhatsApp",
      location: "Canggu · Seminyak · Uluwatu · Ubud",
      heroCaption: "Joinery jati kustom — workshop studio",
      scroll: "Gulir untuk menjelajah",
    },
    marquee: [
      "Interior Kustom",
      "Kitchen Set",
      "Bedroom Set",
      "TV Backdrop",
      "Panel Dinding",
      "Storage",
      "Furnitur Kustom",
      "Desain & Bangun",
    ],
    philosophy: {
      eyebrow: "Filosofi",
      title:
        "Kami merancang ruang yang menghormati material, cahaya, dan kehangatan tenang kehidupan tropis.",
      p1: "Setiap proyek Samasta dimulai dengan mendengarkan — pada arsitekturnya, pada iklimnya, dan pada orang-orang yang akan tinggal serta bekerja di dalamnya. Tidak ada sketsa sebelum kami memahami bagaimana sebuah ruang benar-benar digunakan.",
      p2: "Dari satu panel dinding hingga proyek desain dan bangun yang lengkap, kami memadukan keahlian artisan Bali dengan presisi modern yang bersih — dirancang, difabrikasi, dan dipasang oleh satu tim.",
      link: "Tentang studio",
      caption: "Jati solid — workshop studio",
    },
    services: {
      eyebrow: "Apa yang kami kerjakan",
      title: "Dari satu dinding hingga satu rumah utuh.",
      sub: "Disiplin yang fokus, satu studio — semuanya dirancang, dibangun, dan dipasang secara mandiri.",
      link: "Semua layanan",
      explore: "Jelajahi",
    },
    portfolio: {
      eyebrow: "Karya terpilih",
      title: "Ruang yang telah kami bentuk.",
      link: "Lihat semua proyek",
    },
    process: {
      eyebrow: "Proses",
      title: "Dari percakapan pertama hingga pemasangan akhir.",
      steps: [
        {
          n: "01",
          t: "Konsultasi & Konsep",
          d: "Kami mendengarkan, mengunjungi lokasi, dan membentuk konsep serta arahan anggaran yang jelas.",
        },
        {
          n: "02",
          t: "Desain 3D & Material",
          d: "Anda meninjau visual 3D, sampel material, dan gambar teknis sebelum apa pun dibangun.",
        },
        {
          n: "03",
          t: "Fabrikasi Workshop",
          d: "Furnitur dan joinery Anda dibuat sesuai ukuran di workshop kami di Bali.",
        },
        {
          n: "04",
          t: "Pemasangan & Finishing",
          d: "Tim kami sendiri memasang, mendetail, dan menyerahkan ruang yang selesai.",
        },
      ],
    },
    cta: {
      title: "Siap mewujudkan ruang impian Anda?",
      sub: "Ceritakan proyek Anda — kami biasanya membalas dalam beberapa jam.",
      button: "Konsultasi via WhatsApp",
      chipsLabel: "Atau mulai dari sebuah topik",
      chips: ["Kitchen Set", "Interior Penuh", "TV Backdrop", "Furnitur Kustom"],
    },
  },
  about: {
    hero: {
      eyebrow: "Tentang Samasta Studio",
      line1: "Desain, kayu, dan",
      line2: "ketenangan yang presisi.",
      sub: "Samasta Studio adalah praktik desain interior dan furnitur kustom berbasis di Bali — merancang, membangun, dan memasang semuanya dengan tim kami sendiri.",
    },
    story: {
      eyebrow: "Kisah kami",
      title: "Dua tradisi, satu workshop.",
      p1: "Samasta Studio bekerja pada persimpangan dua dunia: tradisi keahlian kayu yang dalam di pulau ini, dan bahasa desain kontemporer yang minimalis. Hasilnya adalah interior yang tenang dan modern, namun tetap khas Bali.",
      p2: "Dari workshop kami, tim kecil desainer dan tukang kayu menuntun setiap proyek dari percakapan pertama hingga pemasangan akhir — merancang, membangun, dan memasang semuanya sendiri, sehingga tidak ada yang hilang dalam penerjemahan.",
      caption: "Meja kerja workshop",
    },
    values: {
      eyebrow: "Yang kami percayai",
      title: "Cara membangun yang lebih tenang.",
      items: [
        {
          n: "01",
          t: "Dirancang untuk Anda",
          d: "Setiap interior dimulai dari cara Anda tinggal, memasak, bekerja, dan beristirahat — bukan dari gaya yang tetap.",
        },
        {
          n: "02",
          t: "Dibuat, bukan sekadar dirakit",
          d: "Furnitur kami difabrikasi di workshop kami sendiri di Bali, oleh artisan yang bekerja bersama kami setiap hari.",
        },
        {
          n: "03",
          t: "Proses yang jujur",
          d: "Gambar yang jelas, material yang jelas, linimasa yang jelas — dari konsep hingga pemasangan.",
        },
      ],
    },
    materials: {
      eyebrow: "Material",
      title: "Material yang jujur, dibangun untuk iklim tropis.",
      items: [
        {
          t: "Kayu Jati & Kayu Keras",
          d: "Padat, tahan lama, dan seratnya indah — tulang punggung furnitur kami.",
          img: "woodShelves",
        },
        {
          t: "Panel Garis & Fluting",
          d: "Ritme dan bayangan untuk dinding dan plafon, dibuat sesuai ukuran.",
          img: "texture",
        },
        {
          t: "Batu Alam & Terrazzo",
          d: "Dingin di kaki dan tak lekang waktu — untuk dapur, kamar mandi, dan lantai.",
          img: "editorial",
        },
        {
          t: "Rotan & Serat Alam",
          d: "Tekstur tenun yang melembutkan garis-garis modern yang bersih.",
          img: "bedroomCanopy",
        },
      ],
    },
    cta: {
      title: "Mari bicarakan proyek Anda.",
      sub: "Ceritakan tentang ruang Anda — biar kami yang melanjutkannya.",
    },
  },
  servicesPage: {
    hero: {
      eyebrow: "Layanan",
      title: "Interior & furnitur, dibuat pesanan.",
      sub: "Sembilan disiplin yang fokus, satu studio yang bertanggung jawab. Buka sebuah layanan untuk melihat yang termasuk — lalu mulai percakapan via WhatsApp.",
    },
    discuss: "Diskusi via WhatsApp",
    included: "Yang termasuk",
  },
  portfolioPage: {
    hero: {
      eyebrow: "Portofolio",
      title: "Karya yang hidup di Bali.",
      sub: "Pilihan interior, dapur, dan furnitur — dirancang, dibangun, dan dipasang oleh Samasta Studio.",
    },
  },
  contact: {
    hero: {
      eyebrow: "Kontak",
      title: "Mari mulai dari sebuah percakapan.",
      sub: "Tanpa formulir, tanpa menunggu — hubungi kami langsung via WhatsApp dan ceritakan ruang Anda.",
    },
    wa: {
      title: "Chat dengan kami",
      sub: "Cara tercepat menghubungi studio — kami biasanya membalas dalam beberapa jam.",
      button: "Chat via WhatsApp",
      numberLabel: "WhatsApp",
    },
    studio: {
      title: "Studio & workshop",
      locationLabel: "Lokasi",
      location: "Canggu, Bali, Indonesia",
      emailLabel: "Email",
      email: "hello@samastastudio.id",
      hoursLabel: "Jam Kerja",
      hours: "Senin – Sabtu · 09.00 – 17.00 WITA",
    },
    composer: {
      title: "Susun pesan Anda",
      sub: "Pilih topik, tulis sepatah kata — WhatsApp akan terbuka dengan pesan yang siap kirim.",
      serviceLabel: "Saya tertarik pada",
      messageLabel: "Pesan Anda",
      placeholder: "Ceritakan ruang, lokasi, dan linimasa Anda…",
      button: "Kirim via WhatsApp",
      intro: "Halo Samasta Studio,",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Baik untuk diketahui.",
      items: [
        {
          q: "Apakah menerima proyek di luar Bali?",
          a: "Karya kustom dapat dikirim ke pulau lain di Indonesia — kabari kami lokasi Anda dan kita akan membahas pengirimannya.",
        },
        {
          q: "Bisakah memesan furnitur tanpa proyek interior penuh?",
          a: "Ya. Furnitur kustom, kitchen set, dan panel dinding dapat dipesan satu per satu, dibuat sesuai ukuran di workshop kami.",
        },
        {
          q: "Bagaimana sebuah proyek dimulai?",
          a: "Dengan percakapan WhatsApp dan, bila memungkinkan, kunjungan ke lokasi. Dari sana kami menyiapkan konsep, arahan anggaran, dan linimasa.",
        },
        {
          q: "Di mana furnitur dibuat?",
          a: "Di workshop kami sendiri di Bali — dari jati solid, kayu keras, dan plywood premium, dengan finishing tangan.",
        },
        {
          q: "Apakah tersedia layanan desain saja?",
          a: "Ya — layanan desain saja memungkinkan, lengkap dengan gambar detail yang siap untuk tukang Anda sendiri.",
        },
      ],
    },
  },
  footer: {
    blurb:
      "Studio desain interior & furnitur kustom berbasis di Bali — interior kustom, kitchen set, bedroom set, panel dinding, storage, dan furnitur pesanan khusus.",
    menuTitle: "Menu",
    servicesTitle: "Layanan",
    contactTitle: "Kontak",
    location: "Bali, Indonesia",
  },
  categories: [
    { id: "all", label: "Semua Proyek" },
    { id: "villas", label: "Vila & Hunian" },
    { id: "kitchen", label: "Kitchen Set" },
    { id: "bedroom", label: "Kamar Tidur" },
    { id: "panels", label: "Backdrop & Panel" },
    { id: "commercial", label: "Komersial" },
  ],
  services,
  projects,
};
